export default __webpack_public_path__ + "static/media/artistAvatar.7e0e335f.svg";